module.exports = __webpack_public_path__ + "img/topgolf.6d64da75.png";